import {
  factory,
  register as registerOriginal,
  User,
} from '@repo-level/core-front';
import { UpdateFactoryParams } from '@repo-level/core-front/types/common';

export type RegistrationFormApi = Pick<User, 'email' | 'currency'> & {
  password: string;
  termsAgePromosAcceptance: boolean;

  receivePromos: boolean;
  receiveSmsPromos: boolean;
  receivePromosViaPhoneCalls: boolean;
  agreedToPartnerPromotions: boolean;
  receivePromosMain?: boolean; // tech field
};

type RegistrationFormApiParams = Omit<
  RegistrationFormApi,
  'termsAgePromosAcceptance'
> & {
  ageAcceptance?: boolean;
  termsAcceptance?: boolean;
  receivePromos?: boolean;
};

export const register = registerOriginal as UpdateFactoryParams<RegistrationFormApiParams>;

export const confirmationEmailPost = factory((r) => (email: string) =>
  r<null>('post', `users/confirmation`, { user: { email } })
);
